// extracted by mini-css-extract-plugin
module.exports = {"balloon":"_2787e5dfdf--balloon--J9NuV","content":"_2787e5dfdf--content--bBVEI","icon":"_2787e5dfdf--icon--OAxw3"};